import React, { useEffect, useState } from "react";
import {Modal } from "react-bootstrap";
import { addPortfolioList, addtosetupStock } from "../action/api-services";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import { dematNameList } from "../utils/constants";
import { useSelector } from "react-redux";

const ModalSymbolBuy = ({show, onHide, paramsMeta, newEntry}) =>{
        const [startDate, setStartDate] = useState(new Date());
        const [changePrice, setBuyPrice] = useState(0);
        const [buyBudgetAmount, setBuyBudgetAmount] = useState(10000);
        const [toastShown, setToastShown] = useState(false);
        const userToken = useSelector((state) => state.userToken.value);  
        const [getSLPrice, setSLPrice] = useState(0);
        const [getSLPercent, setSLPercent] = useState(0);
        const [getGTTPrice, setGTTPrice] = useState(0);
        const [getGTTPercent, setGTTPercent] = useState(0);

        const [getTara, setTara] = useState("");

        

        useEffect(() => {
                if (!paramsMeta) return;
                
                const watchPrice = parseFloat(paramsMeta.watch_price) || 0;
                const slPrice = parseFloat(paramsMeta.sl_price) || 0;
                const gttPrice = parseFloat(paramsMeta.gtt_price) || 0;

                setBuyPrice(watchPrice.toFixed(2));
                setSLPrice(slPrice.toFixed(2));
                setGTTPrice(gttPrice.toFixed(2));

                if (slPrice > 0) {
                setSLPercent(((watchPrice - slPrice) * 100 / slPrice).toFixed(2));
                }

                if (watchPrice > 0) {
                setGTTPercent(((gttPrice - watchPrice) * 100 / watchPrice).toFixed(2));
                }

                window.calculate(moment(startDate).toDate());
                let panchang = JSON.parse(localStorage.getItem("panchang"));
                setTara(panchang.Tara);


        }, [paramsMeta]);

        const postPortfolioData = (e, submitType) =>{
            e.preventDefault();

            const form = e.target.form;
            const buydate = form.elements.buydate.value;
            const buyprice = form.elements.buyprice.value;
            const buyqty = form.elements.buyqty.value;
            const buyerName = form.elements.buyerName.value;
            const dematName = form.elements.dematName.value;            
            
            if((submitType === 'ADD') && (buydate === '' || buyprice ==='' || buyqty ==='' || buyerName ==='' || dematName ==='')){
                toast.error("Please fill the required field");    
                return false;
            }
    
            
            const params = {
                'source'        : submitType === 'ADD'? "add_to_portfolio":"all_update",
                'newEntry'      : newEntry,
                'symbol'        : paramsMeta.symbol,
                'symbol_Id'     : paramsMeta.id,
                'buy_date'      : moment(buydate, "DD/MM/YYYY").format("YYYY-MM-DD"),
                'method'        : paramsMeta.method,
                [submitType === 'UPDATE'? 'watchlist_price': 'buy_price'] : buyprice,
                'buy_price'     : submitType === 'ADD'? buyprice:'0', 
                'unit_qty'      : buyqty, 
                'buyerName'     : buyerName,
                'dematName'     : dematName,
                'deliveryPer'   : paramsMeta.deliveryPer,
                'strengthCount' : paramsMeta.strengthCount,
                'sl_price'      : paramsMeta.sl_price,
                'gtt_price'     : paramsMeta.gtt_price,
                'buy_tara'      : getTara
            }    

            addPortfolioList(params, userToken).then(function (response) {
               if(response.data.status === true){      
                    toast.success(response.data.message);
                    const element = document.getElementById('item_id_'+paramsMeta.id);
                    if (element && submitType === 'ADD') {
                        element.remove();
                    }
                    onHide();

                }else{
                    toast.error(response.data.message);
                }
            }).catch(function (err) {console.log("Error", err) });
            
        }

        const addtoSetup = (e, obj) =>{
            let params = {
                'symbol' : obj.symbol,
                'setup'  : obj.method
            }
            addtosetupStock(params, userToken).then(function (response) {
               if(response.data.status === true){      
                    toast.success(response.data.message);
                }else{
                    toast.error(response.data.message);
                }
            }).catch(function (err) {console.log("Error", err) });
        }

        
            const buyPriceChangeHandler = (e) =>{
                e.preventDefault();
                
                const inputValue = Number(e.target.value || 0);
                if (!paramsMeta) return;
                let watch_price =  parseFloat(paramsMeta.watch_price);
                let sl_price = parseFloat(paramsMeta?.sl_price);
                let gtt_price =  parseFloat(paramsMeta?.gtt_price);
                
                let curr_DIFF_Price = inputValue - watch_price;
                let slPrice = sl_price + curr_DIFF_Price;
                let gttPrice = gtt_price + curr_DIFF_Price;

                if(inputValue > 0){
                    setBuyPrice(inputValue);
                    setSLPrice(slPrice.toFixed(2));
                    setSLPercent((((inputValue - slPrice) * 100) / slPrice).toFixed(2));
                    setGTTPrice(gttPrice.toFixed(2));
                    setGTTPercent((((gttPrice - inputValue) * 100) / inputValue).toFixed(2));
                }else{
                    setBuyPrice(watch_price.toFixed(2));
                    setSLPrice(sl_price.toFixed(2));
                    setSLPercent((((watch_price - sl_price) * 100) / sl_price).toFixed(2));
                    setGTTPrice(gtt_price.toFixed(2));
                    setGTTPercent((((gtt_price - watch_price) * 100) / watch_price).toFixed(2))
                }
                
            }
        
            const budgetAmountChangeHandler = (e) =>{
                const inputValue = Number(e.target.value);
        
                if (inputValue < Number(changePrice)) {
                  if (!toastShown) {
                    toast.error("Amount should be greater than unit price (" + changePrice + ")");
                    // setToastShown(true);
                  }
                } else {
                  // Reset the flag if input becomes valid again
                  setToastShown(false);
                }
                setBuyBudgetAmount(e.target.value);
            }

            const handleDateChange = (date) => {
                setStartDate(date);

                 window.calculate(moment(date).toDate());
                let panchang = JSON.parse(localStorage.getItem("panchang"));
                setTara(panchang.Tara);
            }

    return(
        <React.Fragment>
        <Modal
            show = {show}
            onHide = {onHide}
            // fullscreen = {true}
            dialogClassName = "watchlist-details"
            // backdrop="static"
            // keyboard={false}
            centered
        >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
            <form>
            <div className="row p-3">
                    <div className="col-12 mb-3" style={{display: "flex", justifyContent: "space-between", width: "100%"}}><span>{paramsMeta.symbol}</span> <span>{getTara}</span></div>
                    <div className="col pe-0">
                            <div className="form-floating">
                            <DatePicker 
                                name="buydate"
                                placeholderText={'Buy date'}
                                className="form-control"
                                selected={startDate} 
                                onChange={(date) => handleDateChange(date)}
                                dateFormat="dd/MM/YYYY"
                                // minDate={moment().subtract(7, "days")}
                                maxDate={new Date()}
                            />
                        <label className="show" htmlFor="buydate">Buy Date</label>
                        </div>
                    </div>
                    <div className="col pe-0">
                            <div className="form-floating">
                                    <input type="text" className="form-control" name="buyprice" id="buyprice" placeholder="Buy Price" defaultValue={0}
                                    onKeyUp={(e) => buyPriceChangeHandler(e)}
                                            // onKeyPress={(event) => { if (!/^\d*\.?\d*$/.test(event.key)) { event.preventDefault(); } }}
                                            onKeyPress={(event) => {
                                                const char = event.key;
                                                const currentValue = event.currentTarget.value;
                                            
                                                if (!/[\d.]/.test(char)) {
                                                  event.preventDefault();
                                                }
                                            
                                                if (char === '.') {
                                                  if (currentValue.includes('.') || currentValue === '') {
                                                    event.preventDefault();
                                                  }
                                                }
                                              }}
                                    />
                                    <label htmlFor="buyprice">Buy Price</label>
                            </div>
                    </div>
                    <div className="col pe-0">
                            <div className="form-floating">
                                    <input type="text" className="form-control" name="buyqty" id="buyqty" placeholder="Buy Qty" 
                                    onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) { event.preventDefault(); } }}
                                    />
                                    <label htmlFor="buyqty">Buy Qty</label>
                            </div>
                    </div>
                    <div className="col pe-0">
                            <div className="form-floating">
                                <select className="form-control" name="buyerName" id="buyerName">
                                    <option value="Pratima">Pratima</option>
                                    <option value="Sanjay">Sanjay</option>
                                </select>
                                <label htmlFor="buyerName">Name</label>
                            </div>
                    </div>
                    <div className="col">
                            <div className="form-floating">
                                <select className="form-control" name="dematName" id="dematName">
                                    {dematNameList?.map((item, index) => (
                                        <option key={index} value={item}>
                                            {item}
                                        </option>
                                    ))}
                                </select>
                                <label htmlFor="dematName">Demat</label>
                            </div>
                    </div>
            </div>
            <div className="row">
                <div className="ps-4 col-auto">
                    <input className="ms-1" style={{width:'100px'}} type="text" defaultValue={buyBudgetAmount} onKeyUp={(e) => budgetAmountChangeHandler(e)}  /> / {changePrice} = {Math.floor(buyBudgetAmount/changePrice)}
                </div>
                <div className=" col pt-1 small">
                    SL = {getSLPrice} [{getSLPercent}%] |  GTT = {getGTTPrice} [{getGTTPercent}%]
                </div>
                <div className="pb-3 pe-4 col-5 text-end">
                    <button type="button" className="btn btn-outline-secondary me-3 px-3" onClick={(e) => addtoSetup(e, paramsMeta)}>Add to Setup</button>
                                    | 
                    {!newEntry && 
                        <button type="button" className="btn btn-outline-primary px-4 me-3 ms-3" onClick={(e) => postPortfolioData(e, 'UPDATE')}>UPDATE</button>
                    }
                        <button type="button" className="btn btn-primary px-4" onClick={(e) => postPortfolioData(e, 'ADD')}>ADD</button>
                    </div>
            </div>
            </form>

            
        </Modal.Body>
      </Modal>
      </React.Fragment>
    )
}
export default ModalSymbolBuy;